/**
 * Which Overview view this device opens on: the Map or the Building (twin
 * slice 1, plan W4 step 10; Decisions 7 and 21).
 *
 * Remembered PER DEVICE, not per account: the site iPad is a shared device
 * (Decision 21), and the person holding it chose what it shows. Map is the
 * default where nothing is remembered (Decision 7: "iPad default view:
 * Map, remembered per device").
 *
 * Only the person's own switch writes it. A link's `view=` is honoured for
 * that landing and NEVER written here: a Chat link someone else made must
 * not change what this iPad opens on tomorrow.
 *
 * Storage can throw (a private window, blocked site data) or come back
 * empty; every read and write is wrapped, and a failure reads as "nothing
 * remembered".
 */
import type { LocateView } from '../../state/locate';

export const OVERVIEW_VIEW_KEY = 'nx.overview.view';

/** Decision 7: the Map, unless this device remembers otherwise. */
export const DEFAULT_OVERVIEW_VIEW: LocateView = '2d';

export function readStoredView(): LocateView | null {
  try {
    const v = window.localStorage.getItem(OVERVIEW_VIEW_KEY);
    return v === '2d' || v === '3d' ? v : null;
  } catch {
    return null;
  }
}

/** The person's own choice, from the Map | Building switch only. */
export function writeStoredView(view: LocateView): void {
  try {
    window.localStorage.setItem(OVERVIEW_VIEW_KEY, view);
  } catch {
    // Not remembered on this device; the view still switches.
  }
}
